import { FC, useState, useEffect, useRef } from 'react';
import AnnouncementBar from './announcement-bar';
import { useQuery, gql } from '@apollo/client';

interface AnnouncementBarEntry {
  title: string;
  bodyCopy: string;
  componentId: string;
  detailsLink: {
    name: string;
    url: string;
  };
}
interface AnnouncementBarData {
  contentfulEntry: AnnouncementBarEntry[];
}

interface AnnouncementBarVars {
  componentId: string;
}

const ANNOUNCEMENT_BAR_FRAGMENT = gql`
  fragment AnnouncementBar on ContentfulEntry {
    title
    bodyCopy
    componentId
    detailsLink {
      name
      url
    }
  }
`;

export const GET_ANNOUNCEMENT_BAR = gql`
  query GetAnnouncementBar($componentId: String!) {
    contentfulEntry(componentId: $componentId, contentTypeId: "announcementBar") {
      ...AnnouncementBar
    }
  }
  ${ANNOUNCEMENT_BAR_FRAGMENT}
`;

interface IAnnouncementBarContainerProps {
  componentId: string;
}

const AnnouncementBarContainer: FC<IAnnouncementBarContainerProps> = ({ componentId }) => {
  const [shouldskipQuery, setShouldskipQuery] = useState(false);
  const queryData = useRef<AnnouncementBarData>();

  const { data, loading, error } = useQuery<AnnouncementBarData, AnnouncementBarVars>(GET_ANNOUNCEMENT_BAR, {
    variables: { componentId },
    skip: shouldskipQuery,
  });

  useEffect(() => {
    // it checks that a query is made and data exists.
    if (!loading && !!data) {
      setShouldskipQuery(true);
      queryData.current = data;
    }
  }, [data, loading]);

  if (loading || error || !queryData.current) {
    return null;
  }

  if (queryData.current.contentfulEntry && !queryData.current.contentfulEntry?.length) return null;

  const { bodyCopy, detailsLink } = queryData.current.contentfulEntry[0];

  return <AnnouncementBar bodyCopy={bodyCopy} detailsLink={detailsLink} />;
};

export default AnnouncementBarContainer;
